import type { ThemePalette } from "./types";

export const oneDark: ThemePalette = {
	id: "one-dark",
	name: "One Dark",
	family: "one-dark",
	appearance: "dark",

	background: "#282c34",
	foreground: "#abb2bf",
	card: "#2c313a",
	cardForeground: "#abb2bf",
	popover: "#2c313a",
	popoverForeground: "#abb2bf",

	primary: "#61afef",
	primaryForeground: "#282c34",
	secondary: "#333842",
	secondaryForeground: "#abb2bf",
	muted: "#333842",
	mutedForeground: "#5c6370",
	accent: "#c678dd",
	accentForeground: "#282c34",
	destructive: "#e06c75",
	destructiveForeground: "#282c34",

	border: "#3e4452",
	input: "#333842",
	ring: "#61afef",

	success: "#98c379",
	warning: "#e5c07b",
	error: "#e06c75",
	info: "#56b6c2",

	chart1: "#61afef",
	chart2: "#c678dd",
	chart3: "#98c379",
	chart4: "#e5c07b",
	chart5: "#56b6c2",
};
